import { normalizeVizType } from '../model/vizSetting';
export function prepareForBackend(view) {
  var _view$private;
  return Object.assign({}, view, {
    currentViewVisualization: normalizeVizType(view.currentViewVisualization),
    private: (_view$private = view.private) !== null && _view$private !== void 0 ? _view$private : false
  });
}